import React from "react";
import { isTestInlinePaymentEvent } from "../utils/ticketConfiguration";

export const TestPaymentModeBanner = ({ className = "", eventData }) => {
  if (!isTestInlinePaymentEvent(eventData)) return null;

  return (
    <div
      className={`alert alert-warning ${className}`.trim()}
      data-testid="test-payment-mode-banner"
      role="alert"
    >
      <strong>Test payment mode is active.</strong> Inline payments will run in
      the test environment; do not enter real card information.
    </div>
  );
};
